import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  switchOrgAccount: {
    id: 'OrganizationSelectorModal.switchAccount',
    defaultMessage: 'Switch account'
  },
  continue: {
    id: 'OrganizationSelectorModal.continue',
    defaultMessage: 'Continue'
  },
  selectAnOrganization: {
    id: 'OrganizationSelectorModal.selectAnOrganization',
    defaultMessage: 'Select an Organization'
  },
  dismiss: {
    id: 'OrganizationSelectorModal.dismiss',
    defaultMessage: 'Dismiss'
  },
  adminHeader: {
    id: 'OrganizationSelectorModal.adminHeader',
    defaultMessage: 'Are you an org admin?'
  },
  adminBody: {
    id: 'OrganizationSelectorModal.adminBody',
    defaultMessage:
      'If not, contact your org admin to activate or <a href="https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/">learn more</a> about Atlassian Intelligence.'
  }
});
